import { enumLabel, type EnumLabelTranslate } from "@/lib/enumLabel";

export function economicEventTypeLabel(
  eventType: string | null | undefined,
  t: EnumLabelTranslate,
): string {
  if (!eventType) return t("shared.emptyCell");
  return enumLabel("eventsList.eventType", eventType, t);
}

export function economicEventStatusLabel(status: string, t: EnumLabelTranslate): string {
  return enumLabel("eventsList.eventStatus", status, t);
}

export function economicAllocationMethodLabel(method: string, t: EnumLabelTranslate): string {
  return enumLabel("eventsList.allocationMethod", method, t);
}
